goog.provide('el8.data.model.checklist');

goog.require('el8.model.base');
goog.require('el8.util.base');


(function() {

    var _ChecklistField = (function() {
        var _class = function(spec) {
            this.populate(spec);
        };
        _class.inheritsFrom(el8_Entity);
        _class.addIntProperty("sequence");
        _class.addStringProperty("name");
        _class.addStringProperty("value");
        _class.addStringProperty('gender'); // only used for checklist templates

        // if true, this means this field is generated by exporting visit note template
        // and we would apply a blue highlight to the field in visit note
        _class.addBoolean('editedByVnt');

        _class.prototype.asMap = function() {
            var m = {};
            m['name'] = this.getName();
            m['value'] = this.getValue();
            m['sequence'] = this.getSequence();
            m['edited_by_vnt'] = this.isEditedByVnt();
            return m;
        };
        return function(spec) { return new _class(spec); };
    })();

    var _class = function(spec) { this.populate(spec); };
    _class.inheritsFrom(el8_Entity);
    _class.prototype.populate = function(spec) {
        spec = spec || {};
        if (spec['fields']) {
            spec['fields'] = spec['fields'].map(_ChecklistField);
        }
        el8_Entity.prototype.populate.call(this, spec);
    };
    _class.addProperty("fields", false, []);
    _class.addStringProperty("type", true);

    var super_getFields = _class.prototype.getFields;
    _class.prototype.getFields = function() {
        var fields = super_getFields.call(this);
        fields.sort(function(a, b) {
            return a.getSequence() - b.getSequence();
        });
        return fields;
    };

    _class.prototype.getFieldNames = function() {
        var fields = this.getFields();
        return fields.map(function(a) { return a.getName(); });
    };

    _class.prototype.getFieldByName = function(name) {
        var fields = this.getFields();
        for (var i=0; i<fields.length; i++) {
            if (fields[i].getName() === name) {
                return fields[i];
            }
        }
        return null;
    };

    _class.prototype.setFieldByName = function(name, value, sequence) {
        var field = this.getFieldByName(name);
        if (field) {
            field.setValue(value);
            if (!el8.util.isNone(sequence)) {
                field.setSequence(sequence);
            }
        } else {
            this.addField(name, value, sequence);
        }
    };

    _class.prototype.addField = function(name, value, sequence) {
        var newField = _ChecklistField({'name': name, 'value': value, 'sequence': sequence});
        var fields = this.getFields();
        fields.push(newField);
        this.setFields(fields);
    };

    _class.prototype.clearAllFields = function() {
        for (var i=0; i<this.getFields().length; i++) {
            this.getFields()[i].setValue('');
        }
    };

    _class.prototype.asObj = function() {
        var result = {};
        for (var i=0; i<this.getFields().length; i++) {
            var field = this.getFields()[i];
            result[field.getName()] = field.getValue();
        }
        return result;
    };

    // an array of field names that should be highlighted
    _class.prototype.getHighlightedFields = function() {
        var result = [];
        for (var i=0; i<this.getFields().length; i++) {
            var field = this.getFields()[i];
            if (field.isEditedByVnt()) {
                result.push(field.getName());
            }
        }
        return result;
    };

    _class.prototype.asFieldMap = function(full) {
        var list = [];
        for (var i=0; i<this.getFields().length; i++) {
            var field = this.getFields()[i];
            if (full || field.getValue()) {
                list.push(field.asMap());
            }
        }
        return list;
    };

    _class.prototype.asMap = function() {
        var m = el8_Entity.prototype.asMap.call(this);
        m['fields'] = this.asFieldMap();
        return m;
    };

    _class.prototype.isEmpty = function() {
        for (var i=0; i<this.getFields().length; i++) {
            if (this.getFields()[i].getValue()) {
                return false;
            }
        }
        return true;
    };

    el8.data.model.checklist = function(spec) {
        return new _class(spec);
    };

    el8.data.model.checklist.field = _ChecklistField;    
})();
